module.exports = __webpack_public_path__ + "kids-image.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-categories/assets/kids-image.png
// module id = 1175
// module chunks = 10